import {
  DirectoryNameConsts,
  DirectoryTypeConsts,
  ItemTypeConsts,
} from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import GettingStartedPanelSettings from 'client/components/GettingStartedPanel/GettingStartedPanelSettings';

const bambooHR = DirectoryNameConsts[DirectoryTypeConsts.bambooHR];
const workday = DirectoryNameConsts[DirectoryTypeConsts.workday];

const hrDirectoryText = featureFlags.bambooRealTimeImport
  ? `Authorize JumpCloud's connection with ${workday} or ${bambooHR} and import user accounts.`
  : `Authorize JumpCloud's connection with ${workday} and import user accounts.`;

const DirectoriesMainPanel = () => import('client/directories/DirectoriesMainPanel.vue');
const WorkdayAsidePanel = () => import('client/directories/Workday/WorkdayAsidePanel');

const directoryProps = {
  hrDirectoryAsidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.workday,
  },
  mainPanel: {
    isAsideOpen: false,
    itemType: ItemTypeConsts.hrDirectory,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'HR Directory Integrations',
  tooltipProps: {
    linkHref: GettingStartedPanelSettings[ItemTypeConsts.hrDirectory].learnMoreUrl,
    pText: hrDirectoryText,
  },
};

export default [
  {
    path: '/directories/hr-directories',
    name: 'hrDirectory',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
    },
    props: {
      inDetailsAsidePanel: false,
      mainPanel: directoryProps.mainPanel,
    },

  },
  {
    path: '/directories/hr-directories/workday/:id/details',
    name: 'hrDirectoryDetails',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: WorkdayAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.hrDirectoryAsidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/directories/hr-directories/workday/new',
    name: 'hrDirectoryNew',
    meta: metaData,
    components: {
      mainPanel: DirectoriesMainPanel,
      asidePanel: WorkdayAsidePanel,
    },
    props: {
      mainPanel: directoryProps.mainPanel,
      asidePanel: route => ({
        ...directoryProps.hrDirectoryAsidePanel,
        itemId: route.params.id,
      }),
    },
  },
];
